<template>
  <div class="hs-slider">
    <div class="slider-text">
      <span>{{ minTips }}</span>
      <span>{{ maxTips }}</span>
    </div>
    <div class="slider-container">
      <van-slider
          ref="refVanSlider"
          v-model="currentValue"
          :step="step"
          :min="min"
          :max="max"
          :activeColor="activeColor"
          :bar-height="barHeight"
          :button-size="buttonSize"
          :range="range"
          @drag-start="dragStart"
          @drag-end="dragEnd"
          @change="change"
      >
        <template v-if="range" #left-button="leftBtnProps">
          <div class="custom-button" @touchstart="touchstart(0)" @touchend="touchend(0)">{{leftBtnProps}}
            <span class="hs-slider-tips" v-if="dragging && dragIndex === 0">￥{{ leftBtnProps.value }}</span>
          </div>
        </template>
        <template v-if="range" #right-button="rightBtnProps">
          <div class="custom-button" @touchstart="touchstart(1)" @touchend="touchend(1)">
            <span class="hs-slider-tips" v-if="dragging && dragIndex === 1">￥{{rightBtnProps.value > max - step ? `${max - step}+` : rightBtnProps.value }}</span>
          </div>
        </template>
        <template v-else #button="btnProps">
          <div class="custom-button">
            <span class="hs-slider-tips" v-if="btnProps.dragging">￥{{ btnProps.value }}</span>
          </div>
        </template>
      </van-slider>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
export default {
  props: {
    step: {
      type: Number,
      default: 1,
    }, // 步长默认 1
    activeColor: {
      type: String,
      default: '#F0182A',
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 100,
    },
    range: {
      type: Boolean,
      default: false
    },
    value: {
      type: [String, Array],
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    barHeight: {
      type: String,
      default: '3px'
    }, // 默认3px
    buttonSize: {
      type: String,
      default: '20px'
    }, // 默认 20px

    /** 自定义的参数 */
    minTips: {
      type: String,
      default: ''
    },
    maxTips: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showTips: false,
      dragIndex: 0,
      dragging: false,
    }
  },
  computed: {
    currentValue: {
      get: function () {
        return this.value
      },
      set: function (val) {
        if (val[1] - val[0] >= 50) {
          this.$emit('input', val)
        }
      }
    }
  },
  methods: {
    dragStart(a, b, c) {
      this.showTips = true
      console.log(a, b, c)
    },

    dragEnd() {
      this.showTips = false
    },

    change(val) {
      if (val[1] - val[0] >= 50) {
        this.$emit('change', val)
      }
    },

    touchstart(index) {
      this.dragIndex = index
      this.dragging = true
    },
    touchend(index) {
      this.dragIndex = index
      this.dragging = false
    }
  }
}
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/base'
@import '~common/stylus/variable'
.hs-slider {
  width: 100%;

  > .slider-text {
    @extend .flex-between;
    @extend .hs-font-caption-1;
    color: $color_black_100;
    margin-bottom: 24px;
  }

  > .slider-container {
    display: flex;
    width: 100%;
    height: 20px;
    position: relative;

    &::before, &::after {
      display: inline-flex;
      content: ' ';
      background-color: $color_black_30;
      width: 10px;
      height: 3px;
    }

    .custom-button {
      width: 20px;
      height: 20px;
      color: #fff;
      font-size: 10px;
      line-height: 18px;
      text-align: center;
      background-color: $color_black_0;
      border-radius: 50vmin;
      box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.18);
      position: relative;

      > .hs-slider-tips {
        @extend .hs-font-overline-1;
        position: absolute;
        top: -12px;
        left: 50%;
        padding: 6px 8px;
        transform: translate(-50%, -100%);
        background: $color_black_600;
        color: $color_black_0;
        border-radius: 6px;
        z-index: 1;

        &::after {
          position: absolute;
          bottom: -7px;
          left: 50%;
          width: 24px;
          height: 8px;
          content: ' ';
          transform: translateX(-50%);
          background: url(@/assets/image/base/hs-slider/triangle.png) no-repeat;
          background-size: 100% 100%;
        }
      }
    }
  }

}
</style>
